import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";
import { AssetLibraryItem, AssetTypeLimit } from "src/app/models/dco/library";

@Injectable({
  providedIn: "root",
})
export class DcoLibraryService extends BaseEntityService {
  private resource_url = `${this.BASE_DCO_URL}/asset-library/`;

  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  getAssetList(params: any = {}) {
    const url = this.buildUrl(this.resource_url, "", params);
    return this.get(url);
  }

  getAssetLimit(params: any = {}) {
    const assetLimiturl = `${this.BASE_DCO_URL}/asset-library/asset-limits`;
    const url = this.buildUrl(assetLimiturl, "", params);
    return this.get(url);
  }

  editAsset(id: number, params) {
    const EditAsseturl = `${this.BASE_DCO_URL}/asset-library/${id}`;
    const url = this.buildUrl(EditAsseturl, "", params);
    return this.get(url);
  }

  updateAsset(
    id: number,
    formData: FormData,
    advertiserId: number
  ): Observable<{ data: AssetLibraryItem }> {
    const params = { advertiser_id: advertiserId.toString() };
    const url = this.buildUrl(`${this.resource_url}${id}/`, "", params);
    return this.put(url, formData);
  }

  createAsset(
    formData: FormData,
    advertiserId: number
  ): Observable<{ data: AssetLibraryItem }> {
    const params = { advertiser_id: advertiserId.toString() };
    const url = this.buildUrl(this.resource_url, "", params);
    return this.post(url, formData);
  }
}
